import {
  SET_CURRENT_DRAWING_TRANSPARENCY,
  SET_CURRENT_HEATMAP_INTENSITY,
  SET_FILTERED_PLANVIEW_LAYERS,
  SET_SENSORDATA_TYPE,
  SET_IS_SENSORDATA_SHOWING,
  SET_CURRENT_MODEL,
  IS_LOADING_MODEL,
  SET_HOVERED_ROOM_AND_SENSOR_VALUE,
  SET_HEATMAP_DATE_ARRAY,
  SET_SELECTED_HEATMAP_DATE,
  SET_ZONE_CATEGORIES_FOR_SELECTED_LEVEL,
  SET_INDOOR_ZONE_DATA_FOR_LEVEL
} from '@/store/mutation-types'
import { STATE } from './state'
import { SENSOR_DATA_ROOM } from '@/interfaces/sensordata.interface'

export default {
  [SET_CURRENT_DRAWING_TRANSPARENCY](state, payload) {
    state.currentDrawingTransparency = payload.currentDrawingTransparency
  },
  [SET_CURRENT_HEATMAP_INTENSITY](state, payload) {
    state.currentHeatmapIntensity = payload.intensity
  },
  [SET_FILTERED_PLANVIEW_LAYERS](state, payload) {
    state.filteredLayers = payload.filteredLayers
  },
  setIsLoadingSensordata(state, isLoading: boolean) {
    state.isLoadingSensordata = isLoading
  },
  [SET_SENSORDATA_TYPE](state, payload) {
    state.currentSensordataType = payload.type
  },
  setSensordataTypes(state, sensordataTypes: string[]) {
    state.sensordataTypesForSelectedLevel = sensordataTypes.sort()
  },
  [SET_IS_SENSORDATA_SHOWING](state, payload) {
    state.isSensordataShowing = payload.value
  },
  [SET_CURRENT_MODEL](state, payload) {
    state.currentModel = payload.type
  },
  [IS_LOADING_MODEL](state, payload) {
    state.isLoadingModel = payload.value
  },
  [SET_HOVERED_ROOM_AND_SENSOR_VALUE](state, payload) {
    if (!payload) state.hoveredSensorData = null
    else state.hoveredSensorData = { room: payload.room, value: payload.value }
  },
  [SET_HEATMAP_DATE_ARRAY](state, payload) {
    state.heatmapDateArray = {
      timeStamps: payload.array,
      date: payload.date
    }
  },
  [SET_SELECTED_HEATMAP_DATE](state, payload) {
    state.selectedHeatmapDate = payload.date
  },
  [SET_INDOOR_ZONE_DATA_FOR_LEVEL](state, payload) {
    state.indoorZonesForSelectedLevel = payload.zones
  },
  [SET_ZONE_CATEGORIES_FOR_SELECTED_LEVEL](state, payload) {
    state.zoneCategoriesForSelectedLevel = payload.categories
  },
  setSensordataForSelectedLevel(state: STATE, sensorData: SENSOR_DATA_ROOM[]) {
    state.sensorDataForSelectedLevel = sensorData
  }
}
